import { useEffect, useState } from 'react';

function getMatches(query: string) {
  return window.matchMedia(query).matches;
}

export default function useMediaQuery(rawQuery: string) {
  // css rules have @media in the query.  remove it since matchMedia won't work
  // if it's there.  this is specifically helpful for the theme breakpoint functions
  // that output "@media <query>"
  const query = rawQuery.replace('@media', '');

  const [matches, setMatches] = useState(getMatches(query));

  useEffect(() => {
    const mqList = window.matchMedia(query);

    function handleChange() {
      setMatches(mqList.matches);
    }

    handleChange();

    mqList.addEventListener('change', handleChange);

    return () => {
      mqList.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}
